/* Histoires Magiques — pages Film : comportements partagés (idempotent, chargé par chaque section) */
(function(){
  if (window.hmfilmPret) { window.hmfilmInit && window.hmfilmInit(); return; }
  window.hmfilmPret = true;

  function une(el, cle){ if (el.dataset[cle]) return false; el.dataset[cle] = '1'; return true; }

  function apparitions(){
    var els = document.querySelectorAll('.hmfilm [data-apparait]');
    function montrer(e){ e.classList.add('vu'); }
    function balayer(){ var h = window.innerHeight; els.forEach(function(e){ if (!e.classList.contains('vu') && e.getBoundingClientRect().top < h * 0.95) montrer(e); }); }
    if (!('IntersectionObserver' in window)) { els.forEach(montrer); return; }
    document.documentElement.classList.add('hmfilm-js');
    var io = new IntersectionObserver(function(entrees){
      entrees.forEach(function(en){ if (en.isIntersecting){ montrer(en.target); io.unobserve(en.target); } });
    }, { threshold: 0, rootMargin: '0px 0px -5% 0px' });
    els.forEach(function(e){ if (une(e, 'obs')) io.observe(e); });
    window.addEventListener('scroll', balayer, { passive: true });
    balayer();
    setTimeout(function(){ els.forEach(montrer); }, 3000);
  }

  function avantApres(){
    document.querySelectorAll('.hmfilm-aa').forEach(function(aa){
      if (!une(aa, 'aa')) return;
      var r = aa.querySelector('input[type=range]');
      function maj(v){ aa.style.setProperty('--pos', v + '%'); }
      if (r){ r.addEventListener('input', function(){ maj(r.value); aa.dataset.touche = '1'; }); maj(r.value); }
      // petite démonstration automatique tant que personne n'a touché
      var t0 = null;
      function demo(ts){
        if (aa.dataset.touche) return;
        if (!t0) t0 = ts;
        var v = 50 + 32 * Math.sin((ts - t0) / 1400);
        maj(v); if (r) r.value = v;
        requestAnimationFrame(demo);
      }
      if (aa.hasAttribute('data-demo') && !matchMedia('(prefers-reduced-motion: reduce)').matches) requestAnimationFrame(demo);
    });
  }

  function onglets(){
    document.querySelectorAll('[data-hmfilm-onglets]').forEach(function(zone){
      if (!une(zone, 'ong')) return;
      var boutons = zone.querySelectorAll('[data-onglet]');
      var panneaux = zone.querySelectorAll('[data-panneau]');
      boutons.forEach(function(b){
        b.addEventListener('click', function(){
          boutons.forEach(function(x){ x.classList.toggle('actif', x === b); });
          panneaux.forEach(function(p){ p.hidden = p.dataset.panneau !== b.dataset.onglet; });
        });
      });
    });
  }

  function galeries(){
    document.querySelectorAll('[data-hmfilm-galerie]').forEach(function(g){
      if (!une(g, 'gal')) return;
      var slides = g.querySelectorAll('[data-slide]');
      var vignettes = g.querySelectorAll('[data-vignette]');
      var i = 0;
      function aller(n){
        i = (n + slides.length) % slides.length;
        slides.forEach(function(s, k){
          s.classList.toggle('actif', k === i);
          var v = s.querySelector('video');
          if (v){ if (k === i) { v.play && v.play().catch(function(){}); } else { v.pause && v.pause(); } }
        });
        vignettes.forEach(function(v, k){ v.classList.toggle('actif', k === i); });
      }
      g.querySelectorAll('[data-prec]').forEach(function(b){ b.addEventListener('click', function(){ aller(i - 1); }); });
      g.querySelectorAll('[data-suiv]').forEach(function(b){ b.addEventListener('click', function(){ aller(i + 1); }); });
      vignettes.forEach(function(v, k){ v.addEventListener('click', function(){ aller(k); }); });
      var x0 = null;
      g.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; }, { passive: true });
      g.addEventListener('touchend', function(e){ if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) aller(i + (dx < 0 ? 1 : -1)); x0 = null; });
      aller(0);
    });
  }

  function videos(){
    document.querySelectorAll('[data-hmfilm-video]').forEach(function(box){
      if (!une(box, 'vid')) return;
      var v = box.querySelector('video'), b = box.querySelector('[data-jouer]');
      if (!v || !b) return;
      b.addEventListener('click', function(){
        document.querySelectorAll('[data-hmfilm-video] video').forEach(function(o){ if (o !== v) o.pause(); });
        v.muted = false; v.controls = true; v.play(); box.classList.add('lecture');
      });
      v.addEventListener('pause', function(){ if (v.currentTime === 0 || v.ended) box.classList.remove('lecture'); });
    });
  }

  function faq(){
    document.querySelectorAll('.hmfilm-faq__q').forEach(function(q){
      if (!une(q, 'faq')) return;
      q.addEventListener('click', function(){ var ouvert = q.getAttribute('aria-expanded') === 'true'; q.setAttribute('aria-expanded', ouvert ? 'false' : 'true'); });
    });
  }

  function paillettes(){
    document.querySelectorAll('.hmfilm-paillettes:not([data-pai])').forEach(function(z){
      z.dataset.pai = '1';
      for (var k = 0; k < 18; k++){
        var i = document.createElement('i');
        i.style.left = (Math.random() * 100) + '%'; i.style.top = (Math.random() * 100) + '%';
        i.style.animationDelay = (Math.random() * 4) + 's'; i.style.transform = 'scale(' + (0.4 + Math.random()) + ')';
        z.appendChild(i);
      }
    });
  }

  window.hmfilmInit = function(){ apparitions(); avantApres(); onglets(); galeries(); videos(); faq(); paillettes(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', window.hmfilmInit); else window.hmfilmInit();
  document.addEventListener('shopify:section:load', window.hmfilmInit);
})();
